// Core
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// Store
import { PersistGate } from 'redux-persist/integration/react';

// Container
import ApplicationBridge
    from './containers/application-bridge-container/ApplicationBridge';
import { CountdownTimer } from './containers/CountdownTimer';
import { ErrorBoundary } from './containers/ErrorBoundary';
import { Header } from './containers/Header';
import { SingleProduct } from './containers/SingleProduct';
import { SoldOutStamp } from './containers/SoldOutStamp';

import createStore from './store/';

const {store, persistor} = createStore();

const configuration = [
    mountFactory('root-header', Header),
    mountFactory('root-single-product', SingleProduct),
    mountFactory('root-soldout-stamp', SoldOutStamp),
    mountFactory('root-application-bridge-container', ApplicationBridge),
    mountFactory('root-countdown-timer', CountdownTimer),
].filter(Boolean);

for (let i = 0; i < configuration.length; ++i) {
    render(configuration[i].component, configuration[i].root);
}

function render(
    Component,
    root,
    ErrorBoundaryComponent = ErrorBoundary,
    errorBoundaryProps = {},
) {
    if (!root) {
        return;
    }

    root.render(
        <Provider store={store}>
            <PersistGate
                loading={null}
                persistor={persistor}
            >
                <ErrorBoundaryComponent {...errorBoundaryProps}>
                    <Component />
                </ErrorBoundaryComponent>
            </PersistGate>
        </Provider>,
    );
}

function mountFactory(selector, component) {
    const node = document.getElementById(selector);
    if (!node) {
        return null;
    }

    return {root: createRoot(node), component};
}
